<template>
    <div class="bg-gray-100">
        <TopLocationHero title-key="kresz_park.title" static-image-key="kresz-park___hero" />
        <div class="relative mt-4 sm:mt-12 z-1">
            <div class="container hidden sm:block">
                <Breadcrumb :items="breadcrumbItems" />
            </div>

            <TopLocationBackgroundShape1 />
        </div>

        <div class="relative">
            <!-- * -->
            <!-- * -->
            <!-- * -->
            <!-- INTRO -->
            <!-- * -->
            <div class="container relative z-2 mt-12">
                <Type6Block
                    featured
                    title-key="kresz_park.intro.title"
                    description-key="kresz_park.intro.description"
                    :images="galleryImages1"
                />

                <!-- * -->
                <!-- * -->
                <!-- * -->
                <!-- FULL-SCALE RENOVATION -->
                <!-- * -->
                <Type8Block
                    title-key="kresz_park.renovation.title"
                    description-key="kresz_park.renovation.description"
                    class="mt-16 sm:mt-20"
                />

                <!-- * -->
                <!-- * -->
                <!-- * -->
                <!-- MINIATURE TOWN -->
                <!-- * -->
                <Type3Block
                    title-key="kresz_park.miniature_town.title"
                    description-key="kresz_park.miniature_town.description"
                    static-image-key="kresz-park___miniature-town"
                    class="mt-16 sm:mt-20"
                />

                <!-- * -->
                <!-- * -->
                <!-- * -->
                <!-- VEHICLES -->
                <!-- * -->
                <Type6Block
                    title-key="kresz_park.vehicles.title"
                    description-key="kresz_park.vehicles.description"
                    details-description-key="kresz_park.vehicles.details_description"
                    :images="galleryImages2"
                    flip-x
                    class="mt-16 sm:mt-20 lg:mt-32"
                />
            </div>

            <TopLocationBackgroundShape4 flip-y class="bottom-32 lg:bottom-36 xl:bottom-44 3xl:bottom-40" />
        </div>

        <div class="container relative z-2 mt-12">
            <!-- * -->
            <!-- * -->
            <!-- * -->
            <!-- PLAYFUL LEARNING -->
            <!-- * -->
            <Type9Block
                title-key="kresz_park.playful_learning.title"
                description-key="kresz_park.playful_learning.description"
                static-image-key="kresz-park___playful-learning"
                class="mt-16 sm:mt-20"
            />

            <!-- * -->
            <!-- * -->
            <!-- * -->
            <!-- FAMILY ACTIVITIES -->
            <!-- * -->
            <Type8Block
                title-key="kresz_park.family_activities.title"
                description-key="kresz_park.family_activities.description"
                class="mt-16 sm:mt-20"
            />
        </div>

        <!-- * -->
        <!-- * -->
        <!-- * -->
        <!-- GALLERY -->
        <!-- * -->
        <XXLGalleryCarousel v-if="galleryImages3" :images="galleryImages3" class="mt-16 sm:mt-20" />

        <div class="container mt-16 sm:mt-20">
            <TopLocationProjectPageBanner
                v-if="$t('kresz_park.event_recommendation_button_url').length && false"
                :button-text="$t('kresz_park.event_recommendation_button_label')"
                :button-url="$t('kresz_park.event_recommendation_button_url')"
                label-text-key="kresz_park.event_recommendation_text"
                type="event"
            />

            <TopLocationProjectPageBanner
                :button-text="$t('kresz_park.visit_project_button_label')"
                :button-url="$t('kresz_park.visit_project_button_url')"
                label-text-key="kresz_park.visit_project_text"
                class="mt-4 sm:mt-8"
            />

            <AwardsBlock
                v-if="awards"
                :title="awards.title"
                :description="awards.description"
                :media="awards.media"
                class="mt-16 sm:mt-20"
            />
        </div>
    </div>
</template>

<script>
import Type9Block from '@/components/Blocks/Type9Block/Type9Block.vue';
import TopLocationProjectPageBanner from '@/components/Pages/TopLocation/TopLocationProjectPageBanner.vue';
import AwardsBlock from '@/components/Blocks/AwardsBlock/AwardsBlock.vue';
import TopLocationHero from '@/components/Pages/TopLocation/Hero/Hero.vue';
import TopLocationBackgroundShape1 from '@/components/Pages/TopLocation/TopLocationBackgroundShape1.vue';
import Type3Block from '@/components/Blocks/Type3Block/Type3Block.vue';
import Type8Block from '@/components/Blocks/Type8Block/Type8Block.vue';
import Type6Block from '@/components/Blocks/Type6Block/Type6Block.vue';
import XXLGalleryCarousel from '@/components/Carousels/XXLGalleryCarousel/XXLGalleryCarousel.vue';
import TopLocationBackgroundShape4 from '@/components/Pages/TopLocation/TopLocationBackgroundShape4.vue';

export default {
    name: 'KreszPark',
    components: {
        TopLocationBackgroundShape4,
        XXLGalleryCarousel,
        Type3Block,
        Type9Block,
        Type6Block,
        AwardsBlock,
        TopLocationProjectPageBanner,
        Type8Block,
        TopLocationBackgroundShape1,
        TopLocationHero,
    },
    async asyncData({ $axios, i18n }) {
        let galleryImages1 = null;
        let galleryImages2 = null;
        let galleryImages3 = null;
        let awards = null;

        await Promise.allSettled([
            $axios.$get('/galleries/reference/top-location___kresz-park-1'),
            $axios.$get('/galleries/reference/top-location___kresz-park-2'),
            $axios.$get('/galleries/reference/top-location___kresz-park-3'),
            $axios.$get('/awards/reference/kresz-park'),
        ])
            .then(([galleryImages1Res, galleryImages2Res, galleryImages3Res, awardsRes]) => {
                if (galleryImages1Res.status === 'fulfilled') {
                    galleryImages1 = galleryImages1Res.value.slides;
                }

                if (galleryImages2Res.status === 'fulfilled') {
                    galleryImages2 = galleryImages2Res.value.slides;
                }

                if (galleryImages3Res.status === 'fulfilled') {
                    galleryImages3 = galleryImages3Res.value.slides;
                }

                if (awardsRes.status === 'fulfilled' && awardsRes.value.is_on_top_locations) {
                    awards = awardsRes.value;
                }
            })
            .catch((err) => {
                console.log(err);
            });

        const breadcrumbItems = [];

        breadcrumbItems.push([i18n.t('navigation.top_locations'), 'top-locations', true]);
        breadcrumbItems.push([i18n.t('kresz_park.title'), 'kresz-park']);

        return {
            galleryImages1,
            galleryImages2,
            galleryImages3,
            awards,
            breadcrumbItems,
        };
    },
    data() {
        return {};
    },
    head() {
        return {
            title: this.$getPageTitle('top-locations.kresz-park'),
            meta: this.$getPageMetaData('top-locations.kresz-park'),
        };
    },
};
</script>

<style scoped></style>
